import FilesLayout from './FilesLayoutLayout';
export default FilesLayout;
